import { ReactElement, useEffect, useState } from "react";
import { IChartWrapperProps } from "../../types";
import { IPieConfig, IPoint } from "../../../../components/charts/types";
import PieChart from "../../../../components/charts/pieChart";
import { getGenericChartConfig } from "./utils";

const PieChartWrapper = ({ cell, data, parentSize, palette, updatePalette, node, schemas }: IChartWrapperProps): ReactElement => {
  const [ chartConfig, setChartConfig ] = useState<IPieConfig | null>(null);

  useEffect(() => {
    if (data) {
      const [ series ] = getGenericChartConfig(data, cell, node, palette, updatePalette, schemas);

      const newSeries = series.map(s => ({
        ...s,
        value: (s.value as IPoint[]).map(p => p.y).reduce((previousValue, currentValue) => previousValue + currentValue)
      }));

      setChartConfig({
        height: parentSize.height,
        width: parentSize.width,
        series: newSeries.sort((a, b) => b.value - a.value),
        seriesDetail: series,
        padAngle: 0.02,
        innerRadius: 0.2,
        seriesRadius: 1.1,
        showLegend: true,
        sort: "NONE"
      });
    }
  }, [ cell, data, parentSize, palette, updatePalette, node, schemas ]);

  return (
    <div className="display-flex-row align-items-center justify-content-center"  style={{ ...parentSize }}>
      {chartConfig && <PieChart pieConfig={chartConfig}/>}
    </div>
  );
};

export default PieChartWrapper;
